module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOrder),
      expression: "isOrder"
    }],
    on: {
      "listenEdit": _vm.showOrder
    }
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "询价单号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入询价单号",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.EnterpriseName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "EnterpriseName", $$v)
      },
      expression: "filters.EnterpriseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "询价时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.hdsjTime
    },
    model: {
      value: (_vm.filters.partnerRegion),
      callback: function($$v) {
        _vm.$set(_vm.filters, "partnerRegion", $$v)
      },
      expression: "filters.partnerRegion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "用户手机："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入手机号",
      "maxlength": "11"
    },
    model: {
      value: (_vm.filters.partnerPhone),
      callback: function($$v) {
        _vm.$set(_vm.filters, "partnerPhone", $$v)
      },
      expression: "filters.partnerPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("客户询价单")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "询价单号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.newInquiryNo
          }
        }, [_vm._v(_vm._s(scope.row.newInquiryNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "询价时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.cTime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "询价类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.inquiryType))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所在城区",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.address))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "房屋面积（㎡）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.housingArea))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "房屋户型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.house))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "询价品类（类型）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.type))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预算(元)",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.budget))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户手机",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.phone))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.state),
            expression: "scope.row.state"
          }],
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.cliSeePartner(scope.row, 1)
            }
          }
        }, [_vm._v("报价")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.state),
            expression: "!scope.row.state"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.cliSeePartner(scope.row, 2)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.totalRowsCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeDetails),
      expression: "seeDetails"
    }],
    staticClass: "main_container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "watch_msg"
  }, [_c('p', {
    staticClass: "typefaceOne"
  }, [_vm._v(_vm._s(_vm.newData.phone) + " 用户的询价信息"), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newData.endTime != '已结束'),
      expression: "newData.endTime!='已结束'"
    }]
  }, [_vm._v("询价截止：" + _vm._s(_vm.newData.endTime))]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newData.endTime == '已结束'),
      expression: "newData.endTime=='已结束'"
    }],
    staticStyle: {
      "color": "#FF6666"
    }
  }, [_vm._v("询价截止：" + _vm._s(_vm.newData.endTime))])]), _vm._v(" "), _c('el-row', {
    staticClass: "elRow"
  }, [_c('el-col', {
    staticClass: "elCol"
  }, [_c('div', {
    staticClass: "elGroup"
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v("询价类型 :")]), _vm._v(" " + _vm._s(_vm.newData.inquiryType) + " ")], 1), _vm._v(" "), _c('div', {
    staticClass: "elGroup"
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v("房屋面积 :")]), _vm._v(" " + _vm._s(_vm.newData.housingArea) + "  ㎡ ")], 1), _vm._v(" "), _c('div', {
    staticClass: "elGroup"
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v("装修风格 :")]), _vm._v(" " + _vm._s(_vm.newData.style) + " ")], 1), _vm._v(" "), _c('div', {
    staticClass: "elGroup"
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v("预算范围 :")]), _vm._v(" " + _vm._s(_vm.newData.budget) + " ")], 1), _vm._v(" "), _c('div', {
    staticClass: "elGroup"
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v("小区名称 :")]), _vm._v(" " + _vm._s(_vm.newData.residentialQuartersName) + " ")], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "elCol"
  }, [_c('div', {
    staticClass: "elGroup"
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v("所在城区 :")]), _vm._v(" " + _vm._s(_vm.newData.address) + " ")], 1), _vm._v(" "), _c('div', {
    staticClass: "elGroup"
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v("房屋户型 :")]), _vm._v(" " + _vm._s(_vm.newData.house) + " ")], 1), _vm._v(" "), _c('div', {
    staticClass: "elGroup",
    attrs: {
      "title": _vm.newData.type
    }
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v(_vm._s(_vm.newData.inquiryTypeId == 1 ? '询价品类' : '装修类型') + " :")]), _vm._v(" " + _vm._s(_vm.newData.type) + " ")], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newData.inquiryTypeId == 1),
      expression: "newData.inquiryTypeId == 1"
    }],
    staticClass: "elGroup"
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v("意向品牌 :")]), _vm._v(" " + _vm._s(_vm.newData.brand) + " ")], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newData.inquiryTypeId == 1),
      expression: "newData.inquiryTypeId == 1"
    }],
    staticClass: "elGroup"
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v("购买数量 :")]), _vm._v(" " + _vm._s(_vm.newData.purchaseNumber) + " ")], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newData.houseTypeImgs && _vm.newData.houseTypeImgs.length > 0),
      expression: "newData.houseTypeImgs && newData.houseTypeImgs.length>0"
    }],
    staticStyle: {
      "margin-bottom": "20px",
      "margin-left": "20px"
    }
  }, [_c('el-button', {
    staticClass: "btnGroup",
    staticStyle: {
      "border": "1px solid #e5e5e5"
    }
  }, [_vm._v("户型图片 :")]), _vm._v(" "), _vm._l((_vm.newData.houseTypeImgs), function(itemImg, index) {
    return _c('span', {
      key: index
    }, [_c('el-image', {
      staticClass: "threeImg",
      attrs: {
        "src": itemImg,
        "preview-src-list": [itemImg]
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newData.inquiryTypeId == 1),
      expression: "newData.inquiryTypeId == 1"
    }],
    staticStyle: {
      "margin-bottom": "20px",
      "margin-left": "20px"
    }
  }, [_c('el-button', {
    staticClass: "btnGroup",
    staticStyle: {
      "border": "1px solid #e5e5e5"
    }
  }, [_vm._v("建材图片 :")]), _vm._v(" "), _vm._l((_vm.newData.buildingMaterialImgs), function(itemImg, index) {
    return _c('span', {
      key: index
    }, [_c('el-image', {
      staticClass: "threeImg",
      attrs: {
        "src": itemImg,
        "preview-src-list": [itemImg]
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newData.inquiryTypeId == 2),
      expression: "newData.inquiryTypeId == 2"
    }],
    staticStyle: {
      "margin-bottom": "20px",
      "margin-left": "20px"
    }
  }, [_c('el-button', {
    staticClass: "btnGroup",
    staticStyle: {
      "border": "1px solid #e5e5e5"
    }
  }, [_vm._v("参考图片 :")]), _vm._v(" "), _vm._l((_vm.newData.referenceImgs), function(itemImg, index) {
    return _c('span', {
      key: index
    }, [_c('el-image', {
      staticClass: "threeImg",
      attrs: {
        "src": itemImg,
        "preview-src-list": [itemImg]
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "elGroup",
    staticStyle: {
      "width": "43.5%"
    }
  }, [_c('el-button', {
    staticClass: "btnGroup"
  }, [_vm._v("询价备注 :")]), _vm._v(" " + _vm._s(_vm.newData.remark) + " ")], 1)])])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-row', {
    staticClass: "elRowBjxx"
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticClass: "dropDown"
  }, [_vm._v(_vm._s(_vm.newData.inquiryTypeId == 1 ? '竞标品牌' : '竞标类型') + " :")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "28%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "disabled": !_vm.seeSub
    },
    on: {
      "change": _vm.changeBidding
    },
    model: {
      value: (_vm.biddingBrand),
      callback: function($$v) {
        _vm.biddingBrand = $$v
      },
      expression: "biddingBrand"
    }
  }, _vm._l((_vm.brandArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newData.inquiryTypeId == 1 && _vm.ordinaryRate),
      expression: "newData.inquiryTypeId == 1 && ordinaryRate"
    }],
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("\r\n              普通让利 : "), _c('b', {
    staticStyle: {
      "color": "#FF6666"
    }
  }, [_vm._v(_vm._s(_vm.ordinaryRate) + "%")]), _vm._v("\r\n              特价让利 : "), _c('b', {
    staticStyle: {
      "color": "#FF6666"
    }
  }, [_vm._v(_vm._s(_vm.promotionRate) + "%")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newData.inquiryTypeId == 2 && _vm.ordinaryRate),
      expression: "newData.inquiryTypeId == 2 && ordinaryRate"
    }],
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("\r\n              让利 : "), _c('b', {
    staticStyle: {
      "color": "#FF6666"
    }
  }, [_vm._v(_vm._s(_vm.ordinaryRate) + "%")])])], 1), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "width": "35%",
      "margin-bottom": "20px",
      "margin-right": "15px"
    },
    attrs: {
      "placeholder": "请输入竞标价格",
      "maxlength": "21",
      "disabled": "!seeSub",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.biddingPrice),
      callback: function($$v) {
        _vm.biddingPrice = $$v
      },
      expression: "biddingPrice"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("竞标价格 :")]), _vm._v(" "), _c('i', {
    staticStyle: {
      "margin-right": "10px",
      "line-height": "36px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])], 2), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#FF6666"
    }
  }, [_vm._v("重要提示：竞标价格请填写未让利前的价格")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticClass: "btnGroup",
    staticStyle: {
      "border": "1px solid #e5e5e5",
      "float": "left"
    }
  }, [_vm._v("说明图片 :")]), _vm._v(" "), _c('div', {
    staticClass: "upPictures"
  }, [_vm._l((_vm.detailImgUrlarr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "multigraph",
      attrs: {
        "data-img": item
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item,
        "preview-src-list": [item]
      },
      on: {
        "click": _vm.handleClickItem
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.seeSub),
        expression: "seeSub"
      }],
      staticClass: "chahao",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deldetail(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      }
    })])], 1)
  }), _vm._v(" "), (_vm.flag < 10) ? _c('el-upload', {
    attrs: {
      "action": "",
      "multiple": "",
      "before-upload": _vm.beforeAvatarUpload,
      "accept": ".png, .jpg,.jpeg"
    }
  }, [(_vm.seeSub) ? _c('i', {
    staticClass: "el-icon-plus upBtn"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "spPicWenan"
  }, [_vm._v("支持JPG,PNG格式图片，最多支持上传10张。")])], 2)], 1), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "beizhu"
  }, [_vm._v("报价备注 :")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "28%"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "maxlength": "500",
      "placeholder": "请输入备注",
      "disabled": !_vm.seeSub
    },
    model: {
      value: (_vm.remarks),
      callback: function($$v) {
        _vm.remarks = $$v
      },
      expression: "remarks"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.showOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.seeSub ? '取消' : '返回'))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seeSub),
      expression: "seeSub"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.btnSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": "请选择店铺",
      "visible": _vm.dialogVisibleadd,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleadd = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "店铺名称："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择店铺"
    },
    model: {
      value: (_vm.bbid),
      callback: function($$v) {
        _vm.bbid = $$v
      },
      expression: "bbid"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("询价详情")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "typefaceTwo"
  }, [_vm._v("报价信息"), _c('span', {
    staticStyle: {
      "color": "#FF6666"
    }
  }, [_vm._v("温馨提示：您的报价如果客户有购买意向，用户的手机号码会全部显示")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e605f5d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderManagement/askForLowPrice.vue
// module id = 1748
// module chunks = 3